import { useRouter } from 'next/router';
import { TightLayout } from '@/components/layout/Layout';
import Contributors from '@/components/ui/contributors/Contributors';
import Contributor from '@/components/ui/contributors/Contributor';

export default function Index() {
  const router = useRouter();
  const username = router.query.username?.[0];

  return (
    <TightLayout>
      {username ? <Contributor username={username} /> : <Contributors />}
    </TightLayout>
  );
}
